export enum EffectiveDate {
    today = 'today',
    hireDate = 'hire_date',
}
